export default __webpack_public_path__ + "static/media/storageUnit1-afterA-480w.ff5937da.avif";